import axios from "axios";
import { getToken } from "../utils/auth";

const API = axios.create({
  baseURL: "https://realestate.alallamtech.com/demo/api-hotels",
  headers: {
    "x-api-key": "a2b794527598611eb9d6bf37c36517bea1b7bf922bd5dba983d5d1a2cac16a54",
    "Content-Type": "application/json"
  }
});

// Attach token if exists
API.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;